import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { EventContext } from '../../../pages/Dashboard';
import { useContext } from "react";
import { Link } from 'react-router-dom';

export default function CustomizedTreeView() {
  const { eventDetails } = useContext(EventContext);

  if (!eventDetails) return "No event loaded";
  return (
    <Card
      variant="outlined"
      sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
    >
      <CardContent>
        <Typography component="span" >Event Meta</Typography>
        
        <Typography component="h6" variant="h6" >{eventDetails ? eventDetails?.eventName : ("Event name not loaded")}</Typography>
        <Typography sx={{ mb: 2 }}>{eventDetails ? eventDetails?.eventDescription : ("Event name not loaded")}</Typography>
        <Typography >{eventDetails ? eventDetails?.eventCode : ("Event name not loaded")}    </Typography>
        <Typography sx={{ mb: 2 }}>{eventDetails?.eventCity}, {eventDetails ? eventDetails?.eventLocation : ("Event name not loaded")} </Typography>
        <Typography>Price: {eventDetails ? eventDetails?.eventPrice : ("Event name not loaded")}</Typography>
        <Typography>Hosted by&nbsp;
          <Link to={`admin/${eventDetails?.eventCode}/people/${eventDetails?.eventOwnerEmail}`}> 
            {eventDetails ? eventDetails?.eventOwnerName : ("Event name not loaded")} {eventDetails?.eventCoOwnerName ? (" and " + eventDetails?.eventCoOwnerName) : ("")}
          </Link>
        </Typography>
        <Typography>Co-host: {eventDetails ? eventDetails?.eventCoOwnerName : ("Event name not loaded")}</Typography>
        <Typography>Price: {eventDetails ? eventDetails?.eventPrice : ("Event name not loaded")}</Typography>
        <Typography>Visibility: {eventDetails ? eventDetails?.eventVisibility : ("Event name not loaded")}</Typography>
        <Typography >Status: {eventDetails ? eventDetails?.eventStatus : ("Event name not loaded")}</Typography>
        <Typography sx={{ mb: 2 }}>{eventDetails ? eventDetails?.eventLongitude : ("Event name not loaded")}</Typography>
        <Typography sx={{ mb: 2 }}>{eventDetails ? eventDetails?.eventLongitude : ("Event name not loaded")}</Typography>
        {/* `/admin/${eventCode}/${item.link}` */}
       
        <Link to={`https://www.openstreetmap.org/#map=11/${eventDetails?.eventLatitude}/${eventDetails?.eventLongitude}`} target='blank'>See on map: {eventDetails ? eventDetails?.eventLatitude : ("Event name not loaded")},{eventDetails ? eventDetails?.eventLongitude : ("Event name not loaded")}</Link>
      </CardContent>
    </Card>
  );
}
